// extracted by mini-css-extract-plugin
export default {"-large":"nP6M39tXlfXjxrCZgxcW","backgroundTransparent":"YuQX5hQ4DdLGb9k43ViQ"};